export const ROUTE_PATHS = {
  HOME: '/',
  SERVICES: '/services',
  ABOUT: '/ueber-uns',
  GALLERY: '/galerie',
  CONTACT: '/kontakt',
} as const;

export interface Service {
  id: string;
  title: string;
  description: string;
  longDescription?: string;
  iconName: string;
  image: string;
  benefits: string[];
  priceStartingFrom?: string;
}

export interface TeamMember {
  id: string;
  name: string;
  role: string;
  bio: string;
  image: string;
  specialization: string;
}

export interface Testimonial {
  id: string;
  name: string;
  rating: number;
  text: string;
  date: string;
  vehicleModel: string;
  location?: string;
}

export type RepairCategory = 'Hagelschaden' | 'Parkschaden' | 'Transportschaden' | 'Sturmschaden';

export function formatDate(dateString: string): string {
  return new Intl.DateTimeFormat('de-DE', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(new Date(dateString));
}

export function cn(...classes: (string | boolean | undefined)[]) {
  return classes.filter(Boolean).join(' ');
}
